import React from 'react'
import config from '../../config.json'

import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import pagesIndex from '../../pages-index'
import Stores from '../Stores'
import Divider from '@mui/material/Divider'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import LogoutIcon from '@mui/icons-material/Logout';

import { Context as StoreContext } from '../../contexts/Store';
import { Badge, Button, Container, Drawer } from '@mui/material';
import { logout } from '../../api';
import { roleTag } from '../../contexts/Auth';

const accordionStyle = {margin: 0, '&.Mui-expanded': {margin: 0}}

const Navigation = () => {
  const { store, assert } = React.useContext(StoreContext)
  const navigate = useNavigate()
  const { pages } = pagesIndex()

  const [expanded, setExpanded] = React.useState([])
  const [open, setOpen] = React.useState(false);

  const navTo = (link) => {
    console.log("Navigating to: ", link);
    (new Promise(resolve => resolve(navigate(link)))).then(assert).then(() => setExpanded([]))
  }

  const handle = (scope) => {
    expanded.includes(scope)?
      setExpanded(expanded.filter(s => s !== scope))
      :setExpanded([...expanded, scope])
  }

  const action = (scope, link) => {
    handle(scope)
    navTo(link)
  }

  const toggleDrawer = (isOpen) => () => {
    setOpen(isOpen);
}

  return (
    <Stack marginBottom="30px" sx={{ borderTop: `5px solid ${store?store.color:'transparent'}`}}>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="sticky">
            <Box height="75px" overflow="visible" sx={{display:'flex', justifyContent:'space-around', alignItems:'center'}}>
              <Box maxHeight="100%" overflow="visible" sx={{display:'flex', justifyContent:'start', alignItems:'start'}}>
                <Box sx={{display:'flex', justifyContent:'start', alignItems:'start', flexWrap: 'wrap'}}>
                  <Accordion sx={accordionStyle} expanded={expanded.includes('app')} onChange={() => handle('app')}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={"app-content"}
                      key={"app-header"}
                      id={"app-header"}
                    >
                      <Typography>Sistema</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {pages.app.map((page, index) => (
                        <ListItemButton key={"navlink-map"+index} onClick={() => action('app', page.link)}>
                          <ListItemIcon>
                            {page.icon}
                          </ListItemIcon>
                          <ListItemText primary={page.name} />
                        </ListItemButton>
                      ))}
                    </AccordionDetails>
                    <Divider/>
                  </Accordion>
                  <Accordion sx={accordionStyle} expanded={expanded.includes('bp')} onChange={() => handle('bp')}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={"bp-content"}
                      key={"bp-header"}
                      id={"bp-header"}
                    >
                      <Typography>Procesos</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {pages.processes.map((page, index) => (
                        <ListItemButton key={"navlink-processes"+index} onClick={() => action('bp', page.link)}>
                          <ListItemIcon>
                            {page.icon}
                          </ListItemIcon>
                          <ListItemText primary={page.name} />
                        </ListItemButton>
                      ))}
                    </AccordionDetails>
                    <Divider/>
                  </Accordion>
                  <Accordion sx={accordionStyle} expanded={expanded.includes('sc')} onChange={() => handle('sc')}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={"sc-content"}
                      key={"sc-header"}
                      id={"sc-header"}
                    >
                      <Typography>Plataformas</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {pages.salesChannels.map((page, index) => (
                        <ListItemButton key={"navlink-salesChannels"+index} onClick={() => action('sc', page.link)}>
                          <ListItemIcon>
                            {page.icon}
                          </ListItemIcon>
                          <ListItemText primary={page.name} />
                        </ListItemButton>
                      ))}
                    </AccordionDetails>
                    <Divider/>
                  </Accordion>
                  <Accordion sx={accordionStyle} expanded={expanded.includes('iv')} onChange={() => handle('iv')}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={"iv-content"}
                      key={"iv-header"}
                      id={"iv-header"}
                    >
                      <Typography>Inventarios</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {pages.inventories.map((page, index) => (
                        <ListItemButton key={"navlink-inventories"+index} onClick={() => action('iv', page.link)}>
                          <ListItemIcon>
                            {page.icon}
                          </ListItemIcon>
                          <ListItemText primary={page.name} />
                        </ListItemButton>
                      ))}
                    </AccordionDetails>
                    <Divider/>
                  </Accordion>
                  {/*                 
                  
                  <Accordion sx={accordionStyle} expanded={expanded.includes('mt')} onChange={() => handle('mt')}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={"mt-content"}
                      key={"mt-header"}
                      id={"mt-header"}
                    >
                      <Typography>Métricas</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {pages.metrics.map((page, index) => (
                        <ListItemButton key={"navlink-metrics"+index} onClick={() => action('mt', page.link)}>
                          <ListItemIcon>
                            {page.icon}
                          </ListItemIcon>
                          <ListItemText primary={page.name} />
                        </ListItemButton>
                      ))}
                    </AccordionDetails>
                    <Divider/>
                  </Accordion>
                  */}
                </Box>
              </Box>
              <Stores></Stores>
              <div>
                <Button
                      sx={{marginLeft:5, marginBottom:.5 , width:150, backgroundColor:"#FFFFFFE0","&:hover": {
                                                                        backgroundColor: '#FFFFFF70' }}}
                      onClick={toggleDrawer(true)}
                    >
                      {localStorage.getItem(config.userName)}
                    </Button>
                <Drawer open={open} anchor='right' onClose={toggleDrawer(false)} >
                    <Box sx={{backgroundColor: '#FFFFFFA0', width:1/4, marginTop:10, marginRight:10, marginBottom:5}}>
                      <Badge sx={{marginLeft:5 ,'& .MuiBadge-badge': {top: -6,}}} badgeContent={roleTag()}  color="primary">
                        <Typography variant="h4" >
                          {localStorage.getItem(config.userName)}
                        </Typography>
                      </Badge>
                    </Box>
                    <Button
                      sx={{marginLeft:5, marginRight:5, marginBottom:.5 , width:150, backgroundColor:"#f6f6f6","&:hover": {
                                                                        backgroundColor: '#FFFFFF70' }}}
                      onClick={logout}
                    >
                      LogOut 
                      <LogoutIcon sx={{marginLeft:1}}/>
                    </Button>
                </Drawer>
              </div>
            </Box>
          
      </AppBar>
    </Box>     
    </Stack>
  )
}

export default Navigation;